import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 py-16 text-center">
      <p className="font-heading text-6xl font-black text-background-300 md:text-8xl">404</p>
      <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        没有找到这个页面
      </h1>
      <p className="mt-2 text-sm text-foreground-400">
        {location.pathname}
      </p>
      <p className="mt-4 max-w-md text-sm text-foreground-500">
        你访问的资源可能已被移除或链接有误，可以返回首页，或前往分类专区继续浏览带中文字幕的影视作品。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-5-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-film-line"></i>
          电影专区
        </Link>
      </div>
    </div>
  );
}